import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_eclectic_wall_art: FaireThemeEntity = {
  token: "discovery_theme_eclectic-wall-art",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Eclectic Wall Art",
  description: "Unique prints and frames for gallery walls",
  bgColor: "#D0D8E8",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
